/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Error_Updatedefaultassignee2Inputs */

const en_cases_settings_error_updatedefaultassignee2 = /** @type {(inputs: Cases_Settings_Error_Updatedefaultassignee2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not update the default assignee`)
};

/**
* | output |
* | --- |
* | "Could not update the default assignee" |
*
* @param {Cases_Settings_Error_Updatedefaultassignee2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_error_updatedefaultassignee2 = /** @type {((inputs?: Cases_Settings_Error_Updatedefaultassignee2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Error_Updatedefaultassignee2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_error_updatedefaultassignee2(inputs)
});
export { cases_settings_error_updatedefaultassignee2 as "cases_settings_error_updateDefaultAssignee" }